import React from 'react';
import FlightEventLanding from '../forms/FlightEvent/FlightEventLanding';
import { FormMetadata } from '../core/api/clients';
import CabinEventLanding from '../forms/CabinEvent/CabinEventLanding';
import DispatchEventLanding from '../forms/DispatchEvent/DispatchEventLanding';
import FlightOperationNotificationLanding from '../forms/FlightOpNotification/FlightOperationNotificationLanding';
import IncidentLanding from '../forms/Incident/IncidentLanding';
import SafetyEventLanding from '../forms/SafetyEvent/SafetyEventLanding';

function getComponent(formMetadata: FormMetadata): JSX.Element {
  switch (formMetadata.componentName) {
    case 'FlightEvent': return <FlightEventLanding formMetadata={formMetadata} />;
    case 'CabinEvent': return <CabinEventLanding formMetadata={formMetadata} />;
    case 'DispatchEvent': return <DispatchEventLanding formMetadata={formMetadata} />;
    case 'FlightOperationNotification': return <FlightOperationNotificationLanding formMetadata={formMetadata} />;
    case 'SafetyEvent': return <SafetyEventLanding formMetadata={formMetadata} />;
    case 'Incident': return <IncidentLanding formMetadata={formMetadata} />;
    // eslint-disable-next-line react/jsx-no-useless-fragment
    default: return <React.Fragment />;
  }
}

function FormListContainer({ formMetadata }: { formMetadata: FormMetadata }) {
  const landingPageComponent = getComponent(formMetadata);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <React.Fragment>
      {landingPageComponent}
    </React.Fragment>
  );
}

export default FormListContainer;
